import React, { SetStateAction, useState, Dispatch, useContext, useMemo } from 'react';

export type TitleType = {
  pageTitle: string;
  setPageTitle: Dispatch<SetStateAction<string>>;
};
export const TitleContext = React.createContext<TitleType>({
  pageTitle: '',
  setPageTitle: () => {},
});

export const useTitleContext = () => useContext(TitleContext);

export const TitleContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [pageTitle, setPageTitle] = useState<string>('');

  const contextTitleProviderValue = useMemo(() => ({ pageTitle, setPageTitle }), [pageTitle]);

  return (
    <TitleContext.Provider value={contextTitleProviderValue}>{children}</TitleContext.Provider>
  );
};
